import { Fragment } from "react";

const TicketLabel = (props) => {
    if(props.item) {
        return(
            <Fragment>
                <span className="text-body d-flex align-items-center gap-1">
                    {props.item.isLocked && <i className="ri-lock-password-fill text-warning" title="Locked"></i>}
                    <span>
                        {props.item.requestNumber}
                        {(props.item.groupCode || props.item.pdGroupCode) ? "[" + (props.item.groupCode || props.item.pdGroupCode) + "]" : ""}
                    </span>
                </span>
                
                
            </Fragment>
        );
    }
    
    return "";
};

export default TicketLabel;